import { FC, PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Skeletons from '../../../components/Skeletons';
import { useAuth } from '../../../hooks/auth';
import { useGetCustomerByIdQuery } from '../../../services/customer/customer-service';
import * as CONSTANTS from '../../constants';

const PFRouteGuard: FC<PropsWithChildren> = () => {
  const { userInfo, authenticatedIsPending } = useAuth();
  const { data: customer, isLoading } = useGetCustomerByIdQuery(
    userInfo.customer || '',
    { skip: !userInfo.customer },
  );

  if (authenticatedIsPending || isLoading) {
    return <Skeletons.LandingPage />;
  }

  // Se for PJ, redireciona para o dashboard
  if (customer?.customerType === 'PJ') {
    return <Navigate to={CONSTANTS.DASHBOARD} replace />;
  }

  return <Outlet />;
};

export default PFRouteGuard;
